export class ValidateAccessGrantResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "valid",
            "baseName": "valid",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "issues",
            "baseName": "issues",
            "type": "Array<DataCatalogValidationIssue>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ValidateAccessGrantResponse.attributeTypeMap;
    }
    constructor() {
    }
}
